const init = (preferences) => {
  PreferencesService.preferences = preferences;
};

const getCurrency = (defaultValue) => {
  if (PreferencesService.preferences?.general?.enabledCurrency && PreferencesService.preferences?.general?.currency) {
    switch (PreferencesService.preferences?.general?.currency) {
      case "dollar":
        return "$";
      case "euro":
        return "€";
      case "pound":
        return "£";
      default:
        return defaultValue;
    }
  }
  return defaultValue;
};

// Singleton - IIFE (Immediately Invoked Function Expression) i
const PreferencesService = (function () {
  return {
    init,
    getCurrency,
    preferences: null,
  };
})();

export default PreferencesService;
